import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import StepRoutes from "../../Routes/steps_routes";
import ButtonWithSVG from "../../Components/layouts/button_with_svg";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import Pagination from "../../Components/layouts/pagination";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import SiUpdateTable from "./Company Assets/Assets_table";
import { FcElectronics } from "react-icons/fc";
import { useLocation, useNavigate } from "react-router";

const CompanyAssets = () => {
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    employee: "",
    status: "",
  });
   const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const pageFromURL = parseInt(queryParams.get("page")) || 1;
    const [page, setPage] = useState(pageFromURL);
    
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [leadOwner, setLeadOwner] = useState();

    useEffect(() => {
      navigate(`?page=${page}`, { replace: true });
    }, [page, navigate]);
  

  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setLeadOwner(res?.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/companyassets/getassets/", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data);
          setTotalPages(Math.ceil(res?.data?.assetsCount / 50));
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
    // .finally(() => setLoading(false));
  }, [refresh, page]);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title">
                    <FcElectronics className="fs-2  me-1" />
                    Company Assets
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
                <div className="col-auto ms-auto d-print-none">
                  <div className="d-flex d-none d-sm-block ">
                    <ButtonWithSVG
                      href={"/company-assets/new"}
                      buttonText="New Assets"
                      svg={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          strokeWidth="2"
                          stroke="currentColor"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M12 5l0 14" />
                          <path d="M5 12l14 0" />
                        </svg>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xxl">
              <div className="row">
                <div className="col-md-3 col-sm-12 py-2">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0">
                            <div className="row">
                              <div className="col-12">
                                <div className="col-12">
                                  <DynamicFilterSelect
                                    label="Select status:"
                                    onChange={(e) => {
                                      setFilters({
                                        ...filters,
                                        status: e.target.value,
                                      });
                                    }}
                                    value={filters.status}
                                  >
                                    <option value="">select all</option>
                                    <option value="available">Available</option>
                                    <option value="pending">Pending</option>
                                    <option value="assigned">Assigned</option>
                                  </DynamicFilterSelect>
                                </div>
                              </div>
                              <div className="col-12">
                                <div className="col-12">
                                  <DynamicFilterSelect
                                    label="Select employee:"
                                    onChange={(e) => {
                                      setFilters({
                                        ...filters,
                                        employee: e.target.value,
                                      });
                                    }}
                                    value={filters.employee}
                                  >
                                    <option value="">select all</option>
                                    {leadOwner &&
                                      leadOwner?.map((lead, index) => {
                                        return (
                                          <option key={index} value={lead?.id}>
                                            {lead?.userName}
                                          </option>
                                        );
                                      })}
                                  </DynamicFilterSelect>
                                </div>
                              </div>
                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => setRefresh(!refresh)}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          employee: "",
                                          status: "",
                                        });
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-body d-none d-md-block">
                          <div className="row">
                            <h3>Filter result</h3>

                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Select status:"
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    status: e.target.value,
                                  });
                                }}
                                value={filters.status}
                              >
                                <option value="">select all</option>
                                <option value="available">Available</option>
                                <option value="pending">Pending</option>
                                <option value="assigned">Assigned</option>
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Select employee:"
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      employee: e.target.value,
                                    });
                                  }}
                                  value={filters.employee}
                                >
                                  <option value="">select all</option>
                                  {leadOwner &&
                                    leadOwner?.map((lead, index) => {
                                      return (
                                        <option key={index} value={lead?.id}>
                                          {lead?.userName}
                                        </option>
                                      );
                                    })}
                                </DynamicFilterSelect>
                              </div>
                            </div>

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        employee: "",
                                        status: "",
                                      });
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-9 col-sm-12 py-2">
                  <div className="card">
                    <SiUpdateTable
                      data={data?.CompanyAsset}
                      currentPage={page}
                      itemsPerPage={50}
                    />

                    <div className="btn-list justify-content-center">
                      <div className="d-lg-none d-md-none mt-3 mb-3">
                        <ButtonWithSVG
                          href={"/farm-training/new"}
                          buttonText="New Farm Training"
                          svg={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              strokeWidth="2"
                              stroke="currentColor"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M12 5l0 14" />
                              <path d="M5 12l14 0" />
                            </svg>
                          }
                        />
                      </div>
                    </div>

                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.CompanyAsset?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default CompanyAssets;
